import axios from 'axios';

export default {
    create(context, data) {
        var options = {
            url: window.apiUrl + '/mentor-note',
            method: 'POST',
            data: data,         
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    update(context, data) {
        var options = {
            url: window.apiUrl + '/mentor-note',
            method: 'PATCH',
            data: data,         
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        }).catch(function(e) {
            console.log(e);
        })
    },

    get(context, query) {
        let url = window.apiUrl + '/mentor-notes';
        if (query) url += query
        var options = {
            url: url,
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    delete(context, id) {
        var options = {
            url: window.apiUrl + '/mentor-note/'+id,
            method: 'DELETE',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
}



// WEBPACK FOOTER //
// ./src/services/mentors/notes.js